import { Layout, Login, AuthCallback } from "@components";
import { ErrorComponent } from "@components/pages/error";
import { PublicLayout } from "@components/publicLayout";
import { SimpleLayout } from "@components/simpleLayout";
import { Home } from "@pages";
import { SellerApplicationForm } from "@pages/home/SellerApplicationForm";
import { authenticatedRoutes } from "./authenticatedRoutes";
import { LandingLayout } from "@components/landingLayout";
import { Landing } from "@pages/landing/page";
import { TermsAndConditions } from "@pages/tnc";
import { SellerPolicies } from "@pages/seller-policies"

export const layouts = [
  {
    element: <LandingLayout />,
    children: [
      {
        path: "/",
        element: <Landing />,
      },
      {
        path: "/terms-and-conditions",
        element: <TermsAndConditions />,
      },
      {
        path: "/seller-policies",
        element: <SellerPolicies />,
      }
    ],
  },
  {
    path: "/individual-callback",
    element: <AuthCallback />,
  },
  {
    path: "/login",
    element: <Login />,
  },

  {
    path: "/error",
    element: <ErrorComponent />,
  },

  {
    element: <SimpleLayout />,
    children: [
      {
        path: "/seller-application",
        element: <SellerApplicationForm />,
      },
    ],
  },

  {
    element: <Layout />,
    children: authenticatedRoutes,
  },
];
